import React from 'react';

const isOverflown = element => element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;

export default class StickyQuestionGroup extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            questionGroupIndex: undefined,
            questionGroupContent: undefined,
            questionGroupImage: undefined,
        };
    }

    componentDidMount() {
        let scrollHandler = this.onScroll.bind(this);

        // Wait for NavBar to get pinned before checking the DOM
        setTimeout(() => {
            $(document).off('scroll').scroll(scrollHandler);
        }, 100);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.questionGroupIndex >= 0 && this.state.questionGroupIndex !== prevState.questionGroupIndex) {
            let $stickyBar = $('.sticky-question-group');
            let $groupTextContainer = $stickyBar.find('.question-group-text-container');

            if (isOverflown($groupTextContainer[0])) {
                $stickyBar.addClass('truncated');
            } else {
                $stickyBar.removeClass('truncated');
            }
        }
    }

    onScroll() {
        let scrollTop = $(window).scrollTop() + 70;

        $('.question-group').each((i, el) => {
            let $questions = $(el).find('.question-container');
            if ($questions.length) {
                let $firstQuestion = $questions.first();
                let $lastQuestion = $questions.last();
                let topY = $firstQuestion.offset().top - 100;
                let bottomY = $lastQuestion.offset().top + $lastQuestion.outerHeight() - 150;

                if (scrollTop >= topY && scrollTop <= bottomY) {
                    this.collapseStickyBar();

                    if (this.state.questionGroupIndex !== i) {
                        this.setState({
                            questionGroupIndex: i,
                            questionGroupContent: $(el).find('.question-group-text').html(),
                            questionGroupImage: $(el).find('.question-group-image').attr('src'),
                        });
                    }
                } else if (this.state.questionGroupIndex === i) {
                    this.setState({questionGroupIndex: undefined});
                }
            }
        });
    }

    onStickyBarClick(e) {
        let $stickyBar = $(e.currentTarget);
        if (!$stickyBar.hasClass('truncated')) return;

        if ($stickyBar.hasClass('expanded')) {
            this.collapseStickyBar($stickyBar);
        } else {
            let height = $stickyBar.find('.question-group-text').outerHeight(true);
            $stickyBar.css('height', height).addClass('expanded');
        }
    }

    collapseStickyBar($stickyBar) {
        if (!$stickyBar) $stickyBar = $('.sticky-question-group');
        $stickyBar.css('height', '').removeClass('expanded');
    }

    render() {
        let visibilityClass = this.state.questionGroupIndex !== undefined ? ' visible' : '';
        let textColumnClass = 'col-12';
        let imageColumn;

        if (this.state.questionGroupImage) {
            textColumnClass = 'col-9 col-md-10';

            imageColumn = (
                <div className="col-3 col-md-2">
                    <a href={this.state.questionGroupImage} target="_blank">
                        <img
                            className="question-group-image img-fluid"
                            src={this.state.questionGroupImage}
                            onClick={e => e.stopPropagation()}
                        />
                    </a>
                </div>
            );
        }

        return (
            <div className={"sticky-question-group" + visibilityClass} onClick={this.onStickyBarClick.bind(this)}>
                <div className="question-group-text-container d-flex align-items-stretch">
                    <div className="row">
                        <div className={textColumnClass+' d-flex align-items-center'}>
                            <div className="question-group-text" dangerouslySetInnerHTML={{__html: this.state.questionGroupContent}} />
                        </div>
                        {imageColumn}
                    </div>
                </div>
            </div>
        );
    }
}
